<p>payment-detail works!</p>
